module.exports = __webpack_public_path__ + "img/14.aa9531db.jpeg";